import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

import { ButtonModule } from "primeng/button";
import { DynamicDialogRef } from "primeng/dynamicdialog";

import { selectQuoteId } from "src/app/store/pages/quote/quote.selectors";
import { selectSelectedCompanyId } from "src/app/store/user/user.selectors";
import { selectQuoteValidation } from "src/app/store/pages/quote/validation/validation.selectors";

@Component({
    selector: "app-validation-errors-dialog",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        ButtonModule,
    ],
    templateUrl: "./validation-errors-dialog.component.html",
    styleUrl: "./validation-errors-dialog.component.scss",
})
export class ValidationErrorsDialogComponent {

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly store = inject(Store);
    private readonly router = inject(Router);
    private readonly dialogRef = inject(DynamicDialogRef);
    private readonly translate = inject(TranslateService);

    // =========================================================================
    // STORE SIGNALS
    // =========================================================================
    public readonly validation = toSignal(this.store.select(selectQuoteValidation));
    private readonly quoteId = toSignal(this.store.select(selectQuoteId));
    private readonly companyId = toSignal(this.store.select(selectSelectedCompanyId));

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================
    public translateError(key: string, params?: Record<string, unknown>): string {
        return this.translate.instant(key, params);
    }

    public navigateToTab(tabSlug: string): void {
        const companyId = this.companyId();
        const quoteId = this.quoteId();
        if (companyId && quoteId) {
            this.router.navigate(["/", companyId, "quote", String(quoteId), tabSlug]);
        }
        this.dialogRef.close();
    }

    public navigateToSubscriptionTab(tabSlug: string): void {
        this.navigateToTab(tabSlug);
    }

    public close(): void {
        this.dialogRef.close();
    }
}
